'use client';
import Spinner from '@/components/Spinner/Spinner';
export default Spinner;